import React, {FC} from 'react'
import {useTheme} from "@mui/material/styles";
import Typography from "@mui/material/Typography";

interface Props {
    title: string
    subtitle?: string | number
}

const TabLabel: FC<Props> = (props) => {
    const theme = useTheme()

    return (
        <Typography variant="subtitle1">
            {props.title} {props.subtitle !== undefined ? <Typography variant="caption"
                                                                      sx={{paddingLeft: theme.spacing(2)}}>{props.subtitle}</Typography> : null}
        </Typography>);
}

export default TabLabel;
